import { DEFAULT_CONFIG } from './default';
import { TAMGA_CONFIG } from './tamga';
import { OVERSIGHT_CONFIG } from './oversight';

const configs = {
  default: DEFAULT_CONFIG,
  tamga: TAMGA_CONFIG,
  oversight: OVERSIGHT_CONFIG,
};
const configType = process.env.VUE_APP_CONFIG || 'default';

if (!configs[configType]) {
  throw new Error(`Unknown configuration: ${configType}`);
}

export const currentConfig = configs[configType];
